<template>
  <v-app-bar text dense fixed app dark color="grey darken-4" :clipped-right="$vuetify.breakpoint.mdAndUp"
    :clipped-left="$vuetify.breakpoint.mdAndUp">
    <v-app-bar-nav-icon @click.stop="leftBar()"></v-app-bar-nav-icon>

    <v-toolbar-title class="body-1">
      {{ getMenuActive }}
    </v-toolbar-title>

    <v-spacer></v-spacer>

    <span style="padding-right: 10px" v-if="nomeSel.Nome">
      {{ nomeSel.Nome }}
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn text icon small v-on="on" @click="rimuoviSwitchUser">
            <v-icon>close</v-icon>
          </v-btn>
        </template>
        <span>Rimuovi filtro</span>
      </v-tooltip>
    </span>

    <span>{{ utente }}</span>

    <v-menu offset-y :nudge-width="200" :close-on-click="true" :close-on-content-click="auth ? true : false"
      v-if="auth">
      <template v-slot:activator="{ on: attrs }">
        <v-btn v-bind="attrs" v-on="attrs" icon>
          <v-icon>account_circle</v-icon>
        </v-btn>
      </template>


      <v-card light>
        <v-list class="pa-0">
          <v-list-item>
            <v-list-item-avatar>
              <v-icon :x-large="true">account_circle</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>Utente:</v-list-item-title>
              <v-list-item-subtitle>{{ utente }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-divider></v-divider>

        <v-card-actions>
          <v-btn color="grey darken-3" text @click="gotoAccount">Account</v-btn>

          <v-spacer></v-spacer>
          <v-btn color="grey darken-3" text @click="esci" :disabled="disabilitaBtn">Esci</v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </v-app-bar>
</template>

<script>
export default {
  props: {
    utente: { type: String, default: "" },
    nomeSel: null,
  },

  data: () => ({
    disabilitaBtn: false,
  }),

  methods: {
    esci() {
      this.disabilitaBtn = true;

      this.$emit("esci");
    },

    leftBar() {
      let v = this.$store.getters["app/getLeftBar"];

      this.$store.commit("app/SET_LEFTBAR", !v);
    },

    gotoAccount() {
      this.$router.push({ path: "profiloUtente" });
    },

    rimuoviSwitchUser() {
      this.$store.commit("user/SET_USERSWITCH", {});
    },
  },

  computed: {
    getMenuActive: function () {
      return this.$store.getters["app/getMenuActive"] || "Home";
    },

    auth() {
      return this.$store.getters["auth/isAuthenticated"];
    },
  },
};
</script>
